<template>
  <div class="dragverifyImgRotate" >
    <van-dialog class="dragVerify-imgRotate" v-model="imgRotateShow" :show-confirm-button="false">
      <div class="toptips">
        <div class="lftips">
          <p >安全验证</p>
          <p class="tipsword">拖动滑块将图片旋转摆正</p>
        </div>
        <div class="rgtips">
          <van-icon @click="close()" class="closeicon" name="close" />
        </div>
      </div>
      <drag-verify-img-rotate 
        ref="dragVerify"
        :imgsrc="dragVerifyImg"
        :isPassing.sync="dragVerifyIsPassing"
        handlerBg="#1a79ff"
        :height="16"
        :width="300"
        background="rgba(153, 153, 153,.6)"
        radius="10px"
        progressBarBg="rgba(153, 153, 153,0)"
        completedBg="rgba(153, 153, 153,0)"
        text=""
        :maxDegree="200"
        successText=""
        handlerIcon="el-icon-d-arrow-right"
        successIcon="el-icon-circle-check"
        @passcallback="succBack()"
        >
      </drag-verify-img-rotate>
    </van-dialog>
  </div>
</template>

<script>
  import {mapState,mapMutations} from "vuex"
  import dragVerifyImgRotate from "vue-drag-verify-img-rotate";
  export default {
    components:{
      dragVerifyImgRotate,
    },
    data(){
      return{
        show:true,
        dragVerifyImg:require('@/assets/img/one.jpg'),
        dragVerifyIsPassing:false,
      }
    },
    methods:{
      ...mapMutations('showData',['changeTFalse']),
      //成功回调
      succBack(){
        //传递成功值
        this.changeTFalse([{name:'imgRotateStatus',value:true}])
        //关闭
        setTimeout(() => {
          this.changeTFalse([{name:'imgRotateShow',value:false}])
          this.$refs.dragVerify.reset()
        }, 500);
      },
      //关闭
      close(){
        this.changeTFalse([{name:'imgRotateShow',value:false}])
        setTimeout(()=>{
          this.$refs.dragVerify.reset()
        },200)
      }
    },
    computed:{
      ...mapState('showData',['imgRotateShow']),
      imgRotateShow:{
        get () {
          return this.$store.state.showData.imgRotateShow
        },
        set (value) {
          this.changeTFalse([{name:'imgRotateShow',value:value}])
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.dragverifyImgRotate{

}
</style>